export const web3ApiUrl = process.env.KULA_API_URL

/**
 * @param {HeadersInit} overrides
 * @returns {HeadersInit}
 */
function setHeaders(overrides = {}) {
  const defaultHeaders = {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
    Accept: 'application/json',
  }

  return { ...defaultHeaders, ...overrides }
}

/**
 * @param {string} url 'url to add to root path
 * @param {{
 *  method?: 'GET'|'POST'|'PUT'|'DELETE'
 *  body?: any
 *  headers?: HeadersInit
 * }} settings 'url to add to root path
 */
export function kulaApiFetch(url, { method = 'GET', body, headers = {} }) {
  /** @type {RequestInit} */
  let reqInit = {
    method: method,
    headers: setHeaders(headers),
    credentials: 'include',
  }

  if (body) reqInit.body = JSON.stringify(body)

  return fetch(web3ApiUrl + url, reqInit)
}
